import React from 'react'
import Icon from 'Pods/Shared/Icon/Icon'

export const faqContent = [
  {
    label: 'How can I use CGTrader coupons?',
    content: (
      <span>
        <p>
          Using CGTrader discount coupons are easy. Here are the steps to take:
        </p>
        <ol>
          <li>
            <b>$20 OFF</b>: Click the "Get Deal" button to register and search
            for models marked with an{' '}
            <Icon className="faq-icon" type={['fas', 'piggy-bank']} /> for a $20
            discount on your first purchase.
          </li>
          <li>
            <b>Free Downloads</b>: Click the "Get Deal" button to register and
            freely download any model of your choice.
          </li>
          <li>
            <b>50% OFF</b>: Click the "Get Deal" button to register and access
            3D models at a 50% discount. Note that you'll receive notifications
            about time-limited deals after signing up.
          </li>
          <li>
            <b>70% OFF</b>: Click the "Get Deal" button to register and access
            3D models at a 50% discount. Note that you'll receive notifications
            about time-limited deals after signing up.
          </li>
        </ol>
      </span>
    ),
  },
  {
    label: 'How long are the coupon codes valid?',
    content: (
      <span>
        Each code has its own unique validity period, which determines how long
        it remains active and can be used for discounts. It's important to note
        that coupons can be deactivated without prior notice, so we recommend
        using them as soon as possible to ensure you can take advantage of the
        savings.
      </span>
    ),
  },
  {
    label: 'Can I use more than one coupon on a single purchase?',
    content: (
      <span>
        Combining multiple codes for a single transaction is not possible. Each
        purchase can only be associated with one coupon.
      </span>
    ),
  },
  {
    label: `What happens if my code doesn't work?`,
    content: (
      <span>
        It has either expired or the 3D model you are trying to purchase is not
        associated with the promotional campaign you are trying to use.
      </span>
    ),
  },
  {
    label:
      'Are there any specific categories or products excluded from discounts?',
    content: (
      <span>
        Please read the coupon description to understand with which promotional
        campaign it should be used. Some categories or products may be excluded
        from discounts.
      </span>
    ),
  },
  {
    label: 'Can I share coupons with others?',
    content: (
      <span>
        Yes, coupons shared on this page are accessible to everyone so you can
        freely share them with others.
      </span>
    ),
  },
]
